// extracted by mini-css-extract-plugin
export var wordContainer = "_qp-0";